import React from 'react';
import { motion } from 'framer-motion';
import { X, Settings, Globe, Lock } from 'lucide-react';

export default function TeamMembersPanel({ team, onRemove, onOpenSettings }) {
  const members = team?.members || [];

  const getDomainStatus = () => {
    if (team?.allowAnyDomain) {
      return { icon: Globe, text: 'Any domain allowed', color: 'text-green-600' };
    } else if (team?.allowedDomains?.length > 0) {
      return {
        icon: Lock,
        text: `${team.allowedDomains.length} domain(s) restricted`,
        color: 'text-blue-600',
      };
    }
    return { icon: Lock, text: 'No domains allowed', color: 'text-red-600' };
  };

  const domainStatus = getDomainStatus();
  const IconComponent = domainStatus.icon;

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      className="rounded-2xl border bg-white p-4 md:p-6"
    >
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h3 className="text-lg font-semibold">Team Members ({members.length})</h3>
          <div className="mt-1 flex items-center space-x-2 text-sm">
            <IconComponent className={`h-4 w-4 ${domainStatus.color}`} />
            <span className={domainStatus.color}>{domainStatus.text}</span>
          </div>
        </div>
        <button
          onClick={onOpenSettings}
          className="flex items-center space-x-2 rounded-xl border px-3 py-2 text-sm hover:bg-slate-50"
          title="Domain settings"
        >
          <Settings className="h-4 w-4" />
          <span>Settings</span>
        </button>
      </div>

      {members.length === 0 ? (
        <div className="rounded-xl border border-dashed p-6 text-slate-600">
          <div className="text-center">
            <p className="mb-2">No team members yet.</p>
            <p className="text-sm">
              {team?.allowAnyDomain
                ? 'Add colleagues using any email address.'
                : `Add colleagues using emails from: ${team?.allowedDomains?.join(', ') || 'allowed domains'}`}
            </p>
          </div>
        </div>
      ) : (
        <div className="flex flex-wrap gap-2">
          {members.map(m => (
            <span
              key={m}
              className="inline-flex items-center gap-2 rounded-full bg-slate-100 px-3 py-1 text-sm"
            >
              {m}
              <button
                onClick={() => onRemove(m)}
                className="rounded-full p-1 hover:bg-slate-200"
                aria-label={`Remove ${m}`}
                title="Remove"
              >
                <X className="h-4 w-4" />
              </button>
            </span>
          ))}
        </div>
      )}
    </motion.div>
  );
}
